/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { useEffect, useState } from 'react';
import { getUserToken, setUserId, setUserToken, setTokenExpireTime, getUserId, getTokenExpireTime, setLoginRedirectUrl } from 'data/storage';
import './index.scss';
import { loginByWorkChat } from 'model/login';
import { useDispatch } from 'react-redux';

const WorkWeChatLogin: React.FC = () => {
  const dispatch = useDispatch();
  const [isWorkWeChatEnter, setIsWorkWeChatEnter] = useState(true);
  const [isAsyncOpen, setIsAsyncOpen] = useState(true);
  const params = urlSerilize(window.location.href);
  useEffect(() => {
    const nowTime = Number(new Date().getTime());
    const { accessToken, userId, hasLogin, expireTime } = params || {};
    setTokenExpireTime(expireTime);
    // 判断是否已经登录
    if (getUserToken()) {
      if (nowTime < Number(expireTime)) {
        dispatch(loginByWorkChat());
      } else if (getUserToken() && getUserId()) {
        setUserToken(accessToken);
        setUserId(userId);
        dispatch(loginByWorkChat());
      } else {
        jumpToHomePage();
      }
      return;
    }

    if (accessToken && userId) {
      setUserToken(accessToken);
      setUserId(userId);
      dispatch(loginByWorkChat());
      if (!expireTime) {
        const date = Number(new Date().getTime()) + 1209600000;
        setTokenExpireTime(date.toString());
      }
      return;
    }

    // 判断是否有登录信息
    if (!accessToken || !userId) {
      if (hasLogin) {
        setIsAsyncOpen(false);
        return;
      }
      setIsWorkWeChatEnter(false);
    }
  }, [params]);
  function jumpToHomePage () {
    if (window) {
      window.location.href = '/';
    }
  };
  function urlSerilize (url: string) {
    const result:any = {};
    if (url.includes('?')) {
      url = url.split('?')[1];
      const map = url.split('&');
      for (let i = 0; i < map.length; i++) {
        result[map[i].split('=')[0]] = map[i].split('=')[1];
      }
      return result;
    }
  }

  return (
    <div>
      {!isWorkWeChatEnter && <div className="work-wechat-tip">请从企业微信进入</div>}
      {!isAsyncOpen && <div className="work-wechat-tip">请在会管后台同步企微账号</div>}
    </div>
  );
};

export default WorkWeChatLogin;
